import { defineMessages } from 'react-intl'

export const sortPopupMessages = defineMessages({
  title: {
    id: 'sortPopupMessages.title',
    description: 'Title for sorting popup',
    defaultMessage: 'Sort List',
  },
})
